import React from "react";
import "./TechnologiesWeOffer.css";
import FeatureCard from "./FeatureCard";
import WebAppIcon from "../../assets/icons/webappicon-removebg-preview.png";
import MobileAppIcon from '../../assets/icons/mobileApplication.png';
import Designing from '../../assets/icons/designing.png';
import ITConsulting from '../../assets/icons/it-service.png';
import Ecommerce from '../../assets/icons/ecommerce.png';
import CMS from "../../assets/icons/content-management-system.png"

const TechnologiesWeServe = () => {
  return (
    <div className="technologiesWeServeMainDiv">
      <div className="container">
        <div className="text-center" data-aos="fade-up">
          <h5 className="industriesTitle">-- What We’re Offering to Our Clients</h5>
          <h1 className="text-4xl font-bold text-yellow-500 Innovative-IT-Solutions-Transforming">
            Innovative IT Solutions  
            <div className="text-teal-400 techTitle">Transforming-Tech Experience</div>
          </h1>
          <p className="mt-4 text-lg text-gray-400 Services_description">
            Our company specializes in comprehensive IT support services that extend from assistance to Web and Mobile app development. We provide the solutions that our customers need to ensure successful digital operations and business success.
          </p>
          <p className="mt-4 text-lg text-gray-400 quote">
            “ Transforming Visions into Digital Reality ”
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-10">
          <div data-aos="fade-up" data-aos-delay="100">
            <FeatureCard
              title="Web Application Development"
              description="Unlock the web’s full potential with StarlinkLab’s powerful web applications. We build scalable, secure, and high-performance solutions, ensuring seamless user experiences and cutting-edge functionality for businesses, 
              enterprises, and SaaS platforms . our expert team ensures excellence at every step."
              icon={WebAppIcon}
            />
          </div>

          <div data-aos="fade-up" data-aos-delay="200">
            <FeatureCard
              title="Mobile App Development"
              description="We empower businesses with a robust Mobile CMS, enabling effortless content management for mobile apps. Our CMS solutions ensure lightning-fast content delivery, seamless updates, and smooth integration with
              both native and cross-platform applications. our expert team ensures excellence at every step."
              icon={MobileAppIcon}
            />
          </div>

          <div data-aos="fade-up" data-aos-delay="300">
            <FeatureCard
              title="UI/UX Design"
              description="Crafting intuitive and visually stunning designs, our UI/UX experts ensure seamless 
              user experiences across all platforms. We focus on user-centric design, blending creativity with 
              functionality to enhance engagement and usability. From wireframes to interactive 
              prototypes."
              icon={Designing}
            />
          </div>

          <div data-aos="fade-up" data-aos-delay="400">
            <FeatureCard
              title="IT Consulting"
              description="StarlinkLab offers expert IT consulting services, helping businesses leverage technology for growth and efficiency. From strategic planning to system integration, 
              we provide tailored solutions that drive innovation, optimize operations, and ensure long-term success."
              icon={ITConsulting}
            />
          </div>

          <div data-aos="fade-up" data-aos-delay="500">
            <FeatureCard
              title="Ecommerce Solutions"
              description="StarlinkLab specializes in eCommerce development, 
              creating immersive shopping experiences with intuitive interfaces and seamless payment integrations.
              Our solutions help businesses reach their target audience and provide a smooth, 
              engaging shopping journey."
              icon={Ecommerce}
            />
          </div>

          <div data-aos="fade-up" data-aos-delay="600">
            <FeatureCard
              title="CMS Development"
              description="StarlinkLab delivers CMS development solutions that empower businesses with seamless content management. Our custom-built CMS ensures easy updates, smooth scalability,
              and intuitive control, enabling you to manage your digital content effortlessly across all platforms."
              icon={CMS}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologiesWeServe;
